import React from 'react'
import {
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  ModalFooter,
  Image,
} from '@chakra-ui/react'
import precaution from '../../../assets/icons/beware.svg'
import infoPopup from '../../../assets/images/Info-popup.svg'
import error from '../../../assets/images/Cancel.svg'


type ButtonColorScheme = 'blue' | 'gray' | 'green' | 'red' | 'orange' | 'cyan' | 'purple' | 'pink' | 'linkedin' | 'facebook' | 'messenger' | 'whatsapp' | 'twitter' | 'telegram' | 'whiteAlpha' | 'blackAlpha' | 'linkedin' | 'facebook' | 'messenger' | 'whatsapp' | 'twitter' | 'telegram' | 'whiteAlpha' | 'blackAlpha' | 'linkedin' | 'facebook' | 'messenger' | 'whatsapp' | 'twitter' | 'telegram' | 'whiteAlpha' | 'blackAlpha' | 'linkedin' | 'facebook' | 'messenger' | 'whatsapp' | 'twitter' | 'telegram' | 'whiteAlpha' | 'blackAlpha' | 'linkedin' | 'facebook' | 'messenger' | 'whatsapp' | 'twitter' | 'telegram' | 'whiteAlpha' | 'blackAlpha' | 'linkedin' | 'facebook' | 'messenger' | 'whatsapp' | 'twitter' | 'telegram' | 'whiteAlpha' | 'blackAlpha'
type ButtonVariant = 'link' | 'outline' | 'solid' | 'ghost' | 'unstyled'

interface ButtonProps {
  color?: ButtonColorScheme;
  variant?: ButtonVariant;
}
interface IBModalActionProps {
  isOpen: boolean
  onClose: () => void
  isloading?: boolean
  title: string
  textBody?: string
  buttonActionText: string
  buttonCancel?: string
  buttonAction?: () => void
  bodyComponent?: React.ReactNode
  iconView?: string
  buttonCancelProps?: ButtonProps
  buttonActionProps?: ButtonProps
  showBanks?: boolean
  closeOnOverlayClick?: boolean
}

const IBModalAction: React.FC<IBModalActionProps> = ({ isOpen, onClose, isloading, title, textBody, buttonCancel, buttonActionText, buttonAction, bodyComponent, iconView, showBanks, closeOnOverlayClick = true }) => (
  <Modal closeOnOverlayClick={closeOnOverlayClick} isOpen={isOpen} onClose={onClose} size={showBanks ? '2xl' : '3xl'} >
    <ModalOverlay />
    <ModalContent p={showBanks ? '20px' : '0 70px 10px 70px'}>
      <ModalHeader textAlign='center' mt={6} mb={2}>
          {iconView === 'precaution'&& (
            <Image mx="auto" src={precaution} mt={4} mb={2} alt="check image" />
          )}
          {iconView === 'info' && (
            <Image mx="auto" src={infoPopup} mt={4} mb={2} alt="info image" />
          )}
          {iconView === 'error' && (
            <Image mx="auto" src={error} mt={4} mb={2} alt="error image" />
          )}
          <Text textStyle='h3'>{title}</Text>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody textAlign='center'>
        <Text>{textBody}</Text>
        {bodyComponent}
      </ModalBody>
      <ModalFooter justifyContent='center'>
        {buttonCancel &&
          <Button mr='6px' onClick={onClose} color='primary.500' variant='outline' borderColor='primary.500'>
            {buttonCancel}
          </Button>
        }
        <Button ml='6px' onClick={buttonAction} minW='110px' isLoading={isloading} data-testid='btn-action'>
          {buttonActionText}
        </Button>
      </ModalFooter>
    </ ModalContent>
  </Modal >
)
export default IBModalAction
